import React, { useEffect, useState } from "react";
import "./personality.css";

// Posters
import battleofsexes from "../../movies/empoderada/battleofthesexes.jpg";
import blue from "../../movies/empoderada/blue.jpg";
import killbill from "../../movies/empoderada/killbill.jpg";
import ladybird from "../../movies/empoderada/ladybird.jpg";
import legallyblonde from "../../movies/empoderada/legallyblonde.jpg";
import littlewoman from "../../movies/empoderada/littlewoman.jpg";
import mulan from "../../movies/empoderada/mulan.jpg";
import pearl from "../../movies/empoderada/pearl.jpg";
import thefavourite from "../../movies/empoderada/thefavourite.jpg";
import theinvisibleman from "../../movies/empoderada/theinvisibleman.jpg";

// Datos reales
const movies = [
  { title: "Battle of the Sexes", image: battleofsexes, director: "Jonathan Dayton, Valerie Faris", year: 2017, cast: "Emma Stone, Steve Carell", synopsis: "La histórica partida de tenis entre Billie Jean King y Bobby Riggs y la lucha por la igualdad de género." },
  { title: "Blue", image: blue, director: "Krzysztof Kieslowski", year: 1993, cast: "Juliette Binoche, Benoît Régent", synopsis: "Una mujer intenta reconstruir su vida tras la muerte de su esposo e hija, explorando libertad y dolor." },
  { title: "Kill Bill", image: killbill, director: "Quentin Tarantino", year: 2003, cast: "Uma Thurman, David Carradine", synopsis: "Una asesina busca venganza contra quienes intentaron matarla y destruyeron su vida." },
  { title: "Lady Bird", image: ladybird, director: "Greta Gerwig", year: 2017, cast: "Saoirse Ronan, Laurie Metcalf", synopsis: "Una adolescente navega por su último año de secundaria y la compleja relación con su madre." },
  { title: "Legally Blonde", image: legallyblonde, director: "Robert Luketic", year: 2001, cast: "Reese Witherspoon, Luke Wilson", synopsis: "Una joven determinada demuestra que es mucho más que su apariencia al estudiar derecho en Harvard." },
  { title: "Little Women", image: littlewoman, director: "Greta Gerwig", year: 2019, cast: "Saoirse Ronan, Emma Watson, Florence Pugh", synopsis: "La vida de las hermanas March mientras buscan amor, éxito y realización personal." },
  { title: "Mulan", image: mulan, director: "Niki Caro", year: 2020, cast: "Liu Yifei, Donnie Yen", synopsis: "Una joven valiente se disfraza de hombre para salvar a su padre y defender a su país." },
  { title: "Pearl", image: pearl, director: "Ti West", year: 2022, cast: "Mia Goth, David Corenswet", synopsis: "La historia de una joven ambiciosa y su obsesión por cumplir sus sueños, incluso a costa de todo." },
  { title: "The Favourite", image: thefavourite, director: "Yorgos Lanthimos", year: 2018, cast: "Olivia Colman, Emma Stone, Rachel Weisz", synopsis: "Intrigas, rivalidades y ambiciones en la corte de la Reina Ana del Reino Unido." },
  { title: "The Invisible Man", image: theinvisibleman, director: "Leigh Whannell", year: 2020, cast: "Elisabeth Moss, Oliver Jackson-Cohen", synopsis: "Una mujer escapa de su abusivo ex y descubre que él puede seguirla invisible, enfrentando el terror psicológico." },
];

// ⭐⭐⭐⭐⭐ STAR SYSTEM (igual que Amorosa)
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient_emp">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient_emp)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Empoderada() {
  useEffect(() => window.scrollTo(0, 0), []);

  // ⭐ STORAGE SEPARADO
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies_Empoderada") || "{}")
  );

  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings_Empoderada") || "{}")
  );

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMovies_Empoderada", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings_Empoderada", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings_Empoderada", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Empoderada</h1>
      <p>
        No hace falta ni describir esto, es la reencarnación de una bruja.
        Nació para la guerra (en el buen sentido). Una mujer que inspira,
        protege, guía y siempre sabe lo que quiere. Su fuerza es tan grande
        que intimida y atrae por igual.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Empoderada;

